/** @jsxImportSource theme-ui */
import * as React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";

export const TestimonialsRow = ({ slice }) => {
  // const image = getImage(slice.primary.testimonial_image);

  return (
    <section sx={{ my: 5 }}>
      {/* — Section title — */}
      <div
        sx={{
          color: "muted",
          textAlign: "center",
          mb: 4,
          fontSize: 4,
        }}
      >
        <PrismicRichText field={slice.primary.testimonials_title.richText} />
      </div>

      {/* — Flex wrapper for all items — */}
      <div
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        {slice.items.map((item, i) => {
          const image = getImage(item.testimonial_image);
          return (
            <div
              key={i}
              sx={{
                width: ["100%", "100%", "48%"],
                display: "flex",
                flexDirection: ["column", "column", "row"],
                alignItems: ["center", "center", "flex-end"],
                mb: 5,
              }}
            >
              {/* Image block unchanged */}
              <div
                sx={{
                  flexShrink: 0,
                  mb: [3, 3, 0],
                  mr: [0, 0, 4],
                  width: ["100%", "auto"],
                  maxWidth: 200,
                }}
              >
                <GatsbyImage
                  image={image}
                  alt={item.testimonial_image.alt}
                  sx={{ width: "100%", height: "auto" }}
                />
              </div>

              {/* Text block now uses a bordered speech-box */}
              <blockquote
                sx={{
                  flex: 1,
                  position: "relative",
                  m: 0,
                  p: 4,
                  border: "1px solid",
                  borderColor: "grey",
                  borderRadius: 2,
                  bg: "background",
                  // top-left opening quote
                  "&::before": {
                    content: '"“"',
                    position: "absolute",
                    bottom: ["0px", "35px", "35px"],
                    right: ["15px", "15px", "15px"],
                    fontSize: 64,
                    color: "muted",
                    lineHeight: 1,
                  },
                  // bottom-right closing quote
                  "&::after": {
                    content: '"”"',
                    position: "absolute",
                    top: ["15px", "15px", "15px"],
                    left: [2, 2, 2],
                    fontSize: 64,
                    color: "muted",
                    lineHeight: 1,
                  },
                  "& p": {
                    fontSize: 3,
                    lineHeight: 1.2,
                    color: "text",
                    fontStyle: "italic",
                  },
                }}
              >
                <PrismicRichText field={item.testimonial_text.richText} />
                <h3 sx={{ mt: 3, fontSize: 3, mb: 0 }}>
                  {item.testimonial_name.text}
                </h3>
              </blockquote>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export const query = graphql`
  fragment AHLTestimonialsrow on PrismicActorsHeadshotsLondonDataBodyTestimonial {
    id
    items {
      testimonial_name {
        richText
        text
      }
      testimonial_image {
        alt
        gatsbyImageData(height: 550)
      }
      testimonial_text {
        richText
      }
    }
    slice_type
    primary {
      testimonial_title {
        richText
      }
    }
  }

  fragment HomeTestimonialsrow on PrismicHomePageDataBodyTestimonials {
    id
    items {
      testimonial_name {
        richText
        text
      }
      testimonial_image {
        alt
        gatsbyImageData(height: 550)
      }
      testimonial_text {
        richText
      }
    }
    slice_type
    primary {
      testimonials_title {
        richText
      }
    }
  }
`;
